import * as Sentry from "@sentry/react";
import { consoleLogger, initLogger } from "@sonic-equipment/ui";

initLogger({
    ...consoleLogger,
    error(message: unknown, error?: unknown, ...args: unknown[]): void {
        Sentry.captureException(error || message, {
            extra: {
                args,
                message: (message as any)?.toJSON ? JSON.stringify((message as any).toJSON(), null, 2) : message,
                error: (error as any)?.toJSON ? JSON.stringify((error as any).toJSON(), null, 2) : error,
            },
        });
        consoleLogger.error(message, error, ...args);
    },
});
